export const TIME_TO_REACH_MEDIUM_LEVEL = 30;
export const TIME_TO_REACH_HARD_LEVEL = 60;
